<template>
  <div>
    <h1 class="subtitle">
      Account Usage
    </h1>
    <div class="account_usage_content">
      <AccountUsagesCard
        :counter="activeAudienceCount"
        :is-loading="audienceLoading"
        :is-total="true"
        :total="audienceCount"
        :allowed="monitoringActionAllowed"
        :error="audiencesActiveError"
        title="Active Audiences"
        @click="goToAudiencesMonitoring('setActiveStatus', audienceLoading, activeAudienceCount, 'audiences')"
      />
      <AccountUsagesCard
        :counter="expiringAudiences"
        :is-loading="expiringAudiencesLoading"
        :allowed="monitoringActionAllowed"
        :error="expiringAudiencesError"
        title="Expiring Audiences"
        @click="goToAudiencesMonitoring('setIsExpiringAudiences', expiringAudiencesLoading, expiringAudiences, 'audiences')"
      />
      <AccountUsagesCard
        :counter="activeTransfersList"
        :is-loading="transfersLoading"
        :is-total="true"
        :total="`${transferList.length}`"
        :allowed="monitoringActionAllowed"
        :error="transfersActiveError"
        title="Active Transfers"
        @click="goToAudiencesMonitoring('setActiveTransfers', transfersLoading, transferList.length, 'transfers')"
      />
      <AccountUsagesCard
        :counter="expiringTransfers"
        :is-loading="expiringTransfersLoading"
        :allowed="monitoringActionAllowed"
        :error="expiringTransfersError"
        title="Expiring Transfers"
        @click="goToAudiencesMonitoring('setIsExpiringTransfers', expiringTransfersLoading, expiringTransfers, 'transfers')"
      />
    </div>
  </div>
</template>
<script>
import AccountUsagesCard from './AccountUsageCard.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { formatNumber } from '@/utils/helpers'

export default {
    name: 'AccountUsage',
    components: {
        AccountUsagesCard
    },
    mounted() {
        this.retrieveExpiringAudiences()
        this.retrieveExpiringTransfers()
    },
    computed: {
        ...mapState('account', {
            accountId: state => state.accountId,
        }),
        ...mapState('data/transfer', {
            transferList: state => state.transferList,
            transfersLoading: state => state.isLoading
        }),
        ...mapGetters({
            expiringAudiences: 'dashboardAccount/expiringAudiences',
            expiringAudiencesError: 'dashboardAccount/expiringAudiencesError',
            expiringAudiencesLoading: 'dashboardAccount/expiringAudiencesLoading',
            expiringTransfers: 'dashboardAccount/expiringTransfers',
            expiringTransfersError: 'dashboardAccount/expiringTransfersError',
            expiringTransfersLoading: 'dashboardAccount/expiringTransfersLoading',
        }),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),
        ...mapGetters({
            totalAudience: 'data/audience/getItems',
            audiencesActiveError: 'data/audience/audiencesActiveError',
            activeAudience: 'data/audience/getActiveItems',
            audienceIsReady: 'data/audience/isReadyForCriteriaList',
        }),
        ...mapGetters({
            transfersActiveError: 'data/transfer/transfersActiveError',
        }),
        activeAudienceCount() {
            return formatNumber(this.activeAudience().length)
        },
        activeTransfersList() {
            return this.transferList.filter(transfer => transfer.status === 'active').length
        },
        audienceLoading() {
            return !this.audienceIsReady()
        },

        audienceCount() {
            return formatNumber(this.totalAudience().length)
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },
    },
    methods: {
        ...mapActions('dashboardAccount', ['retrieveExpiringAudiences', 'getFormulaMetrics', 'retrieveExpiringTransfers']),
        ...mapMutations('dashboardAccount', [
            'setActiveStatus',
            'setLoadingVolumes'
        ]),
        goToAudiencesMonitoring(action, loading, count, type) {
            this.$store.commit('dashboardAccount/' + action, true)
            this.$router.push({ path: '/' + this.accountId + '/monitoring/' + type })
        },
    },
}
</script>
<style lang="scss" scoped>
.account_usage_content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.col-content {
  width: 100%;
}
@media (max-width: 1024px) {
  .account_usage_content {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .account_usage_content {
    grid-template-columns: 1fr;
  }
}
</style>
